<template>
    <app-layout ref="lo" title="Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>

        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <form
                                    class="m-4"
                                    @submit.prevent="saveInfoCompletion"
                                >
                                <Accordion :multiple="true" :activeIndex="[0]">
                                    <AccordionTab header="Data Utama" :disabled="true">
                                        <div class="">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_perusahaan"
                                                    value="Nama Perusahaan"
                                                />
                                                <Input
                                                    id="nama_perusahaan"
                                                    v-model="form.nama_perusahaan"
                                                    type="text"
                                                    placeholder=""
                                                    class="mt-1 block w-full"
                                                    :readonly="true"
                                                />
                                                <InputError
                                                    :message="form.errors.nama_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="npwp_perusahaan"
                                                    value="NPWP Perusahaan"
                                                />
                                                <Input
                                                    id="npwp_perusahaan"
                                                    v-model="form.npwp_perusahaan"
                                                    type="text"
                                                    class="mt-1 block w-full"
                                                    required="required"
                                                    :readonly="true"

                                                />
                                                <InputError
                                                    :message="form.errors.npwp_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_pemberi_kuasa"
                                                    value="Nama Direktur"
                                                />
                                                <Input
                                                    id="nama_pemberi_kuasa"
                                                    v-model="form.nama_pemberi_kuasa"
                                                    type="text"
                                                    placeholder="wajib diisi sesuai dengan KTP"
                                                    class="mt-1 block w-full"
                                                    required="required"

                                                />
                                                <InputError
                                                    :message="form.errors.nama_pemberi_kuasa"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nama_penerima_kuasa"
                                                    value="Nama Penerima Kuasa"
                                                />
                                                <Input
                                                    id="nama_penerima_kuasa"
                                                    v-model="form.nama_penerima_kuasa"
                                                    type="text"
                                                    placeholder="wajib diisi"
                                                    class="mt-1 block w-full"
                                                    required="required"

                                                />
                                                <InputError
                                                    :message="form.errors.nama_penerima_kuasa"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan"
                                                    value="Alamat Perusahaan"
                                                />
                                                <Input
                                                    id="alamat_perusahaan"
                                                    v-model="form.alamat_perusahaan"
                                                    type="text"
                                                    placeholder="wajib diisi"
                                                    class="mt-1 block w-full"
                                                    required="required"
                                                />
                                                <InputError
                                                    :message="form.errors.alamat_perusahaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="alamat_perusahaan_semarang"
                                                    value="Alamat Perusahaan Semarang"
                                                />
                                                <Input
                                                    id="alamat_perusahaan_semarang"
                                                    v-model="form.alamat_perusahaan_semarang"
                                                    type="text"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                />
                                                <InputError
                                                    :message="form.errors.alamat_perusahaan_semarang"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="jenis_pekerjaan"
                                                    value="Jenis Pekerjaan"
                                                />
                                                    <Dropdown class="w-full md:w-14rem" v-model="form.jenis_pekerjaan" :options="selectJenis_pekerjaan" optionLabel="nama_pekerjaan" placeholder="Pilih Jenis Pekerjaan" required="required" >
                                                        <template #option="slotProps">
                                                            <div class="country-item">
                                                                <div>{{slotProps.option.nama_pekerjaan}}</div>
                                                            </div>
                                                        </template>
                                                    </Dropdown>
                                                <InputError
                                                    :message="form.errors.jenis_pekerjaan"
                                                    class="mt-2"
                                                />
                                            </div>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full">
                                            <div class="flex flex-col mb-6">
                                                <div class="w-full px-3 text-center">
                                                    <ButtonSave @click="saveInfoCompletion" label="Simpan Data" />
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data File Tambahan" :disabled="true">

                                        <div class="">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="akta_notaris"
                                                    value="Akta Notaris (bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="akta_notaris"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.akta_notaris = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.akta_notaris"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="nib"
                                                    value="NIB dan Ijin Usaha Liannya (bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="nib"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.nib = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.nib"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="perhitungan_kemampuan_dasar"
                                                    value="Perhitungan Kemampuan Dasar (1 File .pdf)"
                                                />
                                                <Input
                                                    id="perhitungan_kemampuan_dasar"
                                                     type="file"
                                                    multiple="true"
                                                    @input="form.perhitungan_kemampuan_dasar = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.perhitangan_kemampuan_dasar"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="indikator_keuangan"
                                                    value="Indikator Keuangan (SKN) (1 File .pdf)"
                                                />
                                                <Input
                                                    id="indikator_keuangan"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.indikator_keuangan = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.indikator_keuangan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="spt_badan"
                                                    value="SPT Badan beserta lampiran (bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="spt_badan"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.spt_badan = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.spt_badan"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="rekening_koran"
                                                    value="Rekening Koran 3 bulan terakhir (bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="rekening_koran"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.rekening_koran = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.rekening_koran"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="laporan_keuangan_audited"
                                                    value="Laporan Keuangan Audited (jika ada bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="laporan_keuangan_audited"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.laporan_keuangan_audited = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.laporan_keuangan_audited"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="laporan_keuangan_unaudited"
                                                    value="Laporan Keuangan Unaudited(bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="laporan_keuangan_unaudited"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.laporan_keuangan_unaudited = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.laporan_keuangan_unaudited"
                                                    class="mt-2"
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full"
                                                    for="dokumen_lain"
                                                    value="Dokumen Lainnya (bisa lebih dari 1 File .pdf Max 5MB)"
                                                />
                                                <Input
                                                    id="dokumen_lain"
                                                    type="file"
                                                    multiple="true"
                                                    @input="form.dokumen_lain = $event.target.files"
                                                    placeholder="(optional)"
                                                    class="mt-1 block w-full"
                                                    accept="application/pdf"
                                                />
                                                <InputError
                                                    :message="form.errors.dokumen_lain"
                                                    class="mt-2"
                                                />
                                            </div>
                                        </div>
                                        <div class="mt-6 lg:w-full md:w-full">
                                            <div class="flex flex-col mb-6">
                                                <div class="w-full px-3 text-center">
                                                    <ButtonSave @click="saveInfoCompletion" label="Simpan Data" />
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Pegawai / Tanaga Ahli" :disabled="true">
                                        <div class="">
                                            <div class="form-group">
                                                <InputRepeaterPegawai v-model="form.data_pegawai" ></InputRepeaterPegawai>
<!--                                                <pre>{{ form.data_pegawai }}</pre>-->
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Kontrak" :disabled="true">
                                        <div class="">
                                            <div class="form-group">
                                                <InputRepeaterKontrak v-model="form.data_kontrak" ></InputRepeaterKontrak>
<!--                                                <pre>{{ form.data_kontrak }}</pre>-->
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data Barang / Peralatan" :disabled="true">
                                        <div class="">
                                            <div class="form-group">
                                                <InputRepeaterBarang v-model="form.data_barang" ></InputRepeaterBarang>
<!--                                                <pre>{{ form.data_barang }}</pre>-->
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab header="Data KBLI" :disabled="true">
                                        <div class="">
                                            <div class="form-group">
                                                <InputRepeaterKbli v-model="form.data_kbli" ></InputRepeaterKbli>
<!--                                                <pre>{{ form.data_kbli }}</pre>-->
                                            </div>
                                        </div>
                                    </AccordionTab>
                                </Accordion>
                                    <div class="mt-6 lg:w-full md:w-full">
                                        <div class="flex flex-col mb-6">
                                            <div class="w-full px-3 text-center">
                                                <ButtonSave @click="saveInfoCompletion" label="Simpan Data" />
                                            </div>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import ButtonSave from "@/Components/ButtonSave.vue";
import InputRepeaterPegawai from "@/Pages/Penyedia/InputRepeaterPegawai.vue";
import InputRepeaterKontrak from "@/Pages/Penyedia/InputRepeaterKontrak.vue";
import InputRepeaterBarang from "@/Pages/Penyedia/InputRepeaterBarang.vue";
import InputRepeaterKbli from "@/Pages/Penyedia/InputRepeaterKbli.vue";
import InputMask from 'primevue/inputmask';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import FileUpload from 'primevue/fileupload';
import Dropdown from 'primevue/dropdown';




export default defineComponent({
    components: {
        AppLayout,
        BreadCrumb,
        JetLabel,
        Input,
        InputError,
        ButtonSave,
        InputRepeaterPegawai,
        InputRepeaterKontrak,
        InputRepeaterBarang,
        InputRepeaterKbli,
        InputMask,
        Accordion,
        AccordionTab,
        FileUpload,
        Dropdown,
    },
    props: {
            user : Array,
            selectJenis_pekerjaan : Array,
        },
    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
                nama_perusahaan:null,
                npwp_perusahaan:null,
                nama_pemberi_kuasa:null,
                nama_penerima_kuasa:null,
                alamat_perusahaan:null,
                alamat_perusahaan_semarang:null,
                jenis_pekerjaan:null,
                data_pegawai:[],
                data_kontrak:[],
                data_barang:[],
                data_kbli:[],
                akta_notaris:[],
                nib:[],
                perhitungan_kemampuan_dasar:[],
                indikator_keuangan:[],
                dokumen_lain:[],
                spt_badan:[],
                rekening_koran:[],
                laporan_keuangan_audited:[],
                laporan_keuangan_unaudited:[],

            }),
            errors: [],

        };
    },
    mounted(){
        this.form.nama_perusahaan = this.user.nama_perusahaan;
        this.form.npwp_perusahaan = this.user.npwp_perusahaan;

    },
    methods: {
        saveInfoCompletion: function(e){
            //validation form required
            // console.log(this.form);
            if (this.form.nama_pemberi_kuasa == null){
               this.form.errors.nama_pemberi_kuasa = 'Nama Direktur wajib diisi';
               return false;
            }
            if (this.form.nama_penerima_kuasa == null){
                this.form.errors.nama_penerima_kuasa = 'Nama Penerima Kuasa wajib diisi';
                return false;
            }
            if (this.form.alamat_perusahaan == null){
                this.form.errors.alamat_perusahaan = 'Alamat Perusahaan wajib diisi';
                return false;
            }
            if (this.form.jenis_pekerjaan == null){
                this.form.errors.jenis_pekerjaan = 'Jenis Pekerjaan wajib diisi';
                return false;
            }

            e.preventDefault();

            this.form.post(route("penyedia.infocompletion"), {
                errorBag: "saveInfoCompletion",
                preserveScroll: true,
                onSuccess: () => {
                    setTimeout(() => {
                        this.$inertia.get(route("penyedia.showPenyedia", this.user.id));
                    }, 1000);

                },
                onFinish: () => {
                    //
                },
            });
        },
        reset() {
            fire.$emit('reset');
        },

    },
});
</script>

<style >


</style>

